"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classcat = _interopRequireDefault(require("classcat"));

var _react = _interopRequireDefault(require("react"));

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Content = _styledComponents.default.div.withConfig({
  displayName: "Fade__Content",
  componentId: "sc-62ry-0"
})(["opacity:0;transition:opacity ", "ms ease-out;&.entering,&.entered{opacity:1;}"], p => p.duration);

const Fade = ({
  children,
  duration = 200,
  ...other
}) => /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, other, {
  appear: true,
  mountOnEnter: true,
  unmountOnExit: true,
  onEnter: node => node && node.offsetHeight,
  timeout: duration
}), state => /*#__PURE__*/_react.default.createElement(Content, {
  className: (0, _classcat.default)({
    fade__content: true,
    [state]: true
  }),
  duration: duration
}, children));

var _default = Fade;
exports.default = _default;